// extracted by mini-css-extract-plugin
module.exports = {"tag":"Tag_tag__yLh4O","is-small":"Tag_is-small__WULVZ"};